import { render, staticRenderFns } from "./BDXManagementTableFiltersClaimStatus.vue?vue&type=template&id=0c069d18"
import script from "./BDXManagementTableFiltersClaimStatus.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersClaimStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports